import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const Fartsgrense: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon' clipPath='url(#clip0_922_5177)'>
				<path
					id='Vector'
					d='M8 1.5C9.72391 1.5 11.3772 2.18482 12.5962 3.40381C13.8152 4.62279 14.5 6.27609 14.5 8C14.5 9.72391 13.8152 11.3772 12.5962 12.5962C11.3772 13.8152 9.72391 14.5 8 14.5C6.27609 14.5 4.62279 13.8152 3.40381 12.5962C2.18482 11.3772 1.5 9.72391 1.5 8C1.5 6.27609 2.18482 4.62279 3.40381 3.40381C4.62279 2.18482 6.27609 1.5 8 1.5ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM9 3.5C9 3.23478 8.89464 2.98043 8.70711 2.79289C8.51957 2.60536 8.26522 2.5 8 2.5C7.73478 2.5 7.48043 2.60536 7.29289 2.79289C7.10536 2.98043 7 3.23478 7 3.5C7 3.76522 7.10536 4.01957 7.29289 4.20711C7.48043 4.39464 7.73478 4.5 8 4.5C8.26522 4.5 8.51957 4.39464 8.70711 4.20711C8.89464 4.01957 9 3.76522 9 3.5ZM8 12.75C8.96562 12.75 9.75 11.9656 9.75 11C9.75 10.5625 9.59062 10.1625 9.32187 9.85625L11.4375 5.05312C11.6031 4.675 11.4313 4.23125 11.0531 4.06563C10.675 3.9 10.2312 4.07187 10.0656 4.45L7.95 9.25C7.00625 9.275 6.25 10.05 6.25 11C6.25 11.9656 7.03438 12.75 8 12.75ZM6 5C6 4.73478 5.89464 4.48043 5.70711 4.29289C5.51957 4.10536 5.26522 4 5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5C4 5.26522 4.10536 5.51957 4.29289 5.70711C4.48043 5.89464 4.73478 6 5 6C5.26522 6 5.51957 5.89464 5.70711 5.70711C5.89464 5.51957 6 5.26522 6 5ZM3.5 9C3.76522 9 4.01957 8.89464 4.20711 8.70711C4.39464 8.51957 4.5 8.26522 4.5 8C4.5 7.73478 4.39464 7.48043 4.20711 7.29289C4.01957 7.10536 3.76522 7 3.5 7C3.23478 7 2.98043 7.10536 2.79289 7.29289C2.60536 7.48043 2.5 7.73478 2.5 8C2.5 8.26522 2.60536 8.51957 2.79289 8.70711C2.98043 8.89464 3.23478 9 3.5 9ZM13.5 8C13.5 7.73478 13.3946 7.48043 13.2071 7.29289C13.0196 7.10536 12.7652 7 12.5 7C12.2348 7 11.9804 7.10536 11.7929 7.29289C11.6054 7.48043 11.5 7.73478 11.5 8C11.5 8.26522 11.6054 8.51957 11.7929 8.70711C11.9804 8.89464 12.2348 9 12.5 9C12.7652 9 13.0196 8.89464 13.2071 8.70711C13.3946 8.51957 13.5 8.26522 13.5 8Z'
					fill={pathFill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_922_5177'>
					<rect width='16' height='16' fill={pathFill} />
				</clipPath>
			</defs>
		</svg>
	);
};
